module.exports = __webpack_public_path__ + "static/img/celoscope-detail-15.b7f3356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-15.jpg
// module id = Wi1V
// module chunks = 52